import { PortalActions, ReactAtom } from "@mongez/react-atom";
import { FormSubmitOptions } from "@mongez/react-form";
import {
  parseError,
  useGetOrderOptions,
  useSubmitOrderRequest,
} from "core/shared";
import { userAtom } from "core/user";
import { useState } from "react";
import { errorToast } from "~/design-system/components";
import { successPortal } from "../portals";

type useRequestOrderProps = {
  type: "wedding" | "customized";
  portal?: ReactAtom<any, PortalActions>;
  dataAtom: any;
  stepsAtom: any;
};

export function useRequestOrder({
  type,
  portal,
  dataAtom,
  stepsAtom,
}: useRequestOrderProps) {
  const currentDate = new Date();

  const [dateInputName, setDateInputName] = useState<
    "eventDate" | "pickupDate"
  >("eventDate");

  const formData = dataAtom.useValue();

  const user = userAtom.useValue();

  const { orderOptions } = useGetOrderOptions({
    onSuccess: () => {},
    onError: () => {},
  });

  const { handleOrderRequest } = useSubmitOrderRequest(type, {
    onSuccess: () => {
      dataAtom.reset();
      stepsAtom.reset();
    },
    onError: (response) => {
      errorToast(parseError(response.error));
    },
  });

  const handleSubmitUserInformation = ({ values, form }: FormSubmitOptions) => {
    form.submitting(false);
    dataAtom.merge({ customer: values });
    stepsAtom.update(2);
  };

  const handleSubmitOrderRequest = async ({
    values,
    form,
  }: FormSubmitOptions) => {
    const { message, deliveryDate, pickupDate, images, ...data } = values;
    form.submitting(true);
    handleOrderRequest({
      ...formData,
      message,
      deliveryDate,
      pickupDate,
      images,
      data,
    })
      .then(() => {
        successPortal.open();
        portal?.close();
      })
      .catch((error) => {
        console.error(error);
        errorToast(parseError(error));
      })
      .finally(() => {
        form.reset();
      });
  };

  return {
    formData,
    user,
    orderOptions,
    handleSubmitUserInformation,
    handleSubmitOrderRequest,
    currentDate,
    dateInputName,
    setDateInputName,
  };
}
